import info from '@amo/core/assets/images/AMO_Icons/Searching.svg';
import tchat from '@amo/core/assets/images/icons/FAQ.png';
import {BulleAide, Question} from '@amo/core/components/containers';
import { LargeSpinner } from '@amo/core/components/loaders';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {NumeroSerie, Immatriculation} from '@amo/core/components/questions';
import getFormuleChoisie from '../Tarif/utilsTarif/getFormuleChoisie';
import DateHeureEffet from './DateHeureEffet/DateHeureEffet';
import RecapPersonne from './RecapPersonne/RecapPersonne';
import RecapTarif from './RecapTarif/RecapTarif';
import RecapVehicule from './RecapVehicule/RecapVehicule';

/*
 * Sur la première arrivée du visiteur sur le récap (typiquement lien d'avenant
 * Subscribe="1"), /init contient déjà l'évaluation du code promo et la formule
 * sauvegardée avec ses prix promo. /get_tarif rejoue l'évaluation et peut écraser
 * la promo dans state.tarif. On fige donc l'usage des données /init pour ce premier
 * affichage uniquement. Si l'utilisateur sort puis revient, on retombe sur le
 * comportement habituel basé sur state.tarif.
 */
let recapInitConsumed = false;

const Recapitulatif = (props) => {
    const {
        data,
        postPaySubmit,
        formules,
        payLoaded,
        nomPrenom,
        changeValue,
        isLoadedTarif,
        queryTarif,
        postReloadTarif,
        source,
        pdfDevis,
        dispositionGenerale,
        documentInformation,
        lettreRGPD,
        assistancePanne,
        initTarifCodePromo,
        initDevisFormule,
        formOptions,
        formOptionsFranchise,
        formOptionsListe,
        fractionnementChoisi,
    } = props;
    const formuleChoisie = getFormuleChoisie(data, formules);
    const [tryPost, setTryPost] = useState(false);
    const [dateHeureEffetError, setDateHeureEffetError] = useState(null);
    const [useInitData] = useState(() => !recapInitConsumed);

    useEffect(() => {
        if (tryPost) {
            isNotValid();
        }
    }, [data, tryPost]);

    useEffect(() => {
        changeValue('DemandeContrat[NomTitulaire]', nomPrenom);
        if (!isLoadedTarif) {
            postReloadTarif({ form: data, query: queryTarif });
        }
        recapInitConsumed = true;
    }, []);

    const computeRecapTarifPropsFromInit = () => {
        if (!initDevisFormule || !initTarifCodePromo?.Eligible) return null;

        let priceMonthly = initDevisFormule.PrimeMensuelleBase || 0;
        let priceMonthlyPromo = initDevisFormule.PrimeMensuelleBasePromo || priceMonthly;
        let priceAnnual = initDevisFormule.PrimeAnnuelleFracAnnuelBase || 0;
        let priceAnnualPromo = initDevisFormule.PrimeAnnuelleFracAnnuelBasePromo || priceAnnual;

        const addOption = (code) => {
            const opt = (initDevisFormule.ListeGaranties || []).find(
                (g) => g.CodeGarantie === code && g.Disponible === 'Option',
            );
            if (!opt) return;
            priceMonthly += opt.PrimeClientMensuelle || 0;
            priceMonthlyPromo += opt.PrimeClientMensuellePromo ?? opt.PrimeClientMensuelle ?? 0;
            priceAnnual += opt.PrimeClient || 0;
            priceAnnualPromo += opt.PrimeClientPromo ?? opt.PrimeClient ?? 0;
        };

        _.forEach(formOptions, (code) => code && addOption(code));
        _.forEach(formOptionsFranchise, (val, code) => {
            if (val === 'true' || val === true) addOption(code);
        });
        _.forEach(formOptionsListe, (_v, code) => addOption(code));

        // En fractionnement mensuel, l'annuel affiché doit inclure les frais de fractionnement,
        // donc on prend les totaux PrimeAnnuelleFracChoisi(Promo) déjà calculés côté back.
        if (fractionnementChoisi === 'M') {
            if (initDevisFormule.PrimeAnnuelleFracChoisi != null) {
                priceAnnual = initDevisFormule.PrimeAnnuelleFracChoisi;
            }
            if (initDevisFormule.PrimeAnnuelleFracChoisiPromo != null) {
                priceAnnualPromo = initDevisFormule.PrimeAnnuelleFracChoisiPromo;
            }
        }

        return {
            codePromo: initTarifCodePromo,
            prixTotalMensuel: priceMonthly,
            prixTotalMensuelPromo: priceMonthlyPromo,
            prixTotalAnnuel: priceAnnual,
            prixTotalAnnuelPromo: priceAnnualPromo,
        };
    };

    const recapTarifOverrides = useInitData ? computeRecapTarifPropsFromInit() : null;

    /* Function qui ajoute la class error sur les champs vide */
    const handleError = (fieldName, remove) => {
        _.forEach(document.getElementsByName(fieldName), (input) => {
            if (input.getAttribute('type') === 'radio') {
                if (remove) {
                    input.labels[0].classList.remove('error');
                } else {
                    input.labels[0].classList.add('error');
                }
            } else {
                if (remove) {
                    input.classList.remove('error');
                } else {
                    input.classList.add('error');
                }
            }
        });
        if (fieldName === 'DemandeContrat[DateHeureEffet]') {
            if (remove) {
                setDateHeureEffetError(null);
            } else {
                setDateHeureEffetError("Pensez à saisir l'heure en indiquant JJ/MM/YYYY 00:00");
            }
        }
    };

    const isNotValid = () => {
        let notValid = false;
        let fields = [
            `DemandeContrat[DateHeureEffet]`,
        ];

        if (!_.includes(['quad', 'verte'], data?.typeVehicule)) {
            fields.unshift(`DemandeTarif[Vehicule][Immatriculation]`);
        }

        if (_.get(data, 'DemandeTarif[Police][MotifAvenant]') !== '8') {
            fields.push('debutContrat');
        }

        fields.forEach((field) => {
            if (!_.get(data, field) && field !== '') {
                handleError(field);
                notValid = true;
            } else {
                handleError(field, true);
            }
            if (field === 'DemandeContrat[BIC]' && !_.get(data, field)) {
                document.getElementById('btn-check-iban').style.color = 'red';
                document.getElementById('btn-check-iban').style.borderColor = 'red';
                document.getElementById('btn-check-iban').style.backgroundColor = 'transparent';
            }
        });

        if (!moment(_.get(data, 'DemandeContrat[DateHeureEffet]'), 'DD/MM/YYYY HH:mm', true).isValid() || !_.get(data, 'DateEffetContrat') || !_.get(data, 'HeureEffetContrat')) {
            handleError('DemandeContrat[DateHeureEffet]');
            notValid = true;
        }

        return notValid;
    };

    const myPostPaySubmit = () => {
        setTryPost(true);
        if (isNotValid()) {
            document.getElementsByClassName('error')[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            postPaySubmit();
        }
    };

    const hasErrorOnPage = () => {
        const errorDivs = document.querySelectorAll('.alert.alert-danger.invalid-feedback.d-block');
        return errorDivs.length > 0;
    };

    const getBulleAideContent = () => {
        if (source === 'site') {
            return {
                title: 'Jusqu\'à 30 JOURS D\'ASSURANCE pour trouver le bon acheteur',
                text: `<p>Votre ancien véhicule est assuré jusqu'à 30 jours <strong>uniquement dans le cadre d'essais en vue de la vente.</strong></p>
                  <p>Votre nouveau véhicule est assuré, et en plus, votre ancien véhicule bénéficie des <strong>mêmes options et garanties mais uniquement dans le cadre de la vente.</strong></p>`
            };
        } else {
            return {
                title: 'Assuré éligible à l\'assurance transitoire',
                text: `<p>L'ancien véhicule conservé temporairement en vue de la vente, bénéficie des mêmes garanties et options que celles du nouveau véhicule, uniquement s'il est mis en circulation pour des essais en vue de la vente et pour une durée maximale de 30 jours à compter du jour où l'assurance a été reportée sur le nouveau véhicule.</p>`
            };
        }
    };

    return (
        <>
            {isLoadedTarif ? (
                <>
                    {payLoaded ? (
                        <LargeSpinner message={'Patientez quelques instants'} />
                    ) : (
                        <div id={'etape-recap'}>
                            <Question loader icon={info} title={'Récapitulatif'} full>
                                <div className="row justify-content-center">
                                    <div className="col-12 my-2 px-3 py-2 bg-white rounded border">
                                        <RecapTarif {...props} {...recapTarifOverrides} formuleChoisie={formuleChoisie} />
                                        <hr/>
                                        <div className="row">
                                            <RecapVehicule {...props} formuleChoisie={formuleChoisie} />

                                            <RecapPersonne {...props} />

                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <div className="rounded px-4 pb-3">
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <img
                                                                src={tchat}
                                                                alt="Documents"
                                                                width={30}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                        <div className="col-10">
                                                            <p className="f-14 text-primary fw-bold" style={{textAlign: 'left'}}>
                                                                Mes documents à télécharger
                                                            </p>
                                                            <div className="d-block">
                                                                {pdfDevis && (
                                                                    <a
                                                                        href={pdfDevis}
                                                                        target="_blank"
                                                                        download
                                                                        className="btn btn-light btn-pdf btn-block mb-2"
                                                                    >
                                                                        Proposition d'assurance
                                                                    </a>
                                                                )}
                                                                {dispositionGenerale && (
                                                                    <a
                                                                        href={dispositionGenerale}
                                                                        target="_blank"
                                                                        download
                                                                        className="btn btn-light btn-pdf btn-block mb-2"
                                                                    >
                                                                        Dispositions Générales
                                                                    </a>
                                                                )}
                                                                {documentInformation && (
                                                                    <a
                                                                        href={documentInformation}
                                                                        target="_blank"
                                                                        download
                                                                        className="btn btn-light btn-pdf btn-block mb-2"
                                                                    >
                                                                        Document d'information produit
                                                                    </a>
                                                                )}
                                                                {lettreRGPD && (
                                                                    <a
                                                                        href={lettreRGPD}
                                                                        target="_blank"
                                                                        download
                                                                        className="btn btn-light btn-pdf btn-block mb-2"
                                                                    >
                                                                        Lettre RGPD
                                                                    </a>
                                                                )}
                                                                {assistancePanne && (
                                                                    <a
                                                                        href={assistancePanne}
                                                                        target="_blank"
                                                                        download
                                                                        className="btn btn-light btn-pdf btn-block"
                                                                    >
                                                                        Annexes Assistance
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {((_.get(data, 'DemandeTarif[Vehicule][VehiculeImmatricule]') == true && _.includes(['quad', 'verte'], data?.typeVehicule)) || (!_.includes(['quad', 'verte'], data?.typeVehicule))) ?
                                    <>
                                        <h3 className={'f-16 text-center fw-bold mt-5'}>Informations Complémentaires</h3>
                                        <Immatriculation {...props} required />
                                    </>
                                    : <NumeroSerie {...props} />
                                }

                                <DateHeureEffet {...props} formuleChoisie={formuleChoisie} dateHeureEffetError={dateHeureEffetError}/>
                            </Question>

                            {(_.includes(['moto', 'scooter'], data?.typeVehicule) &&
                                _.get(data, 'DemandeTarif[ListeContratsBelair][0][VehiculeBelair][EligibleTransitoire]') &&
                                _.get(data, 'DemandeTarif[Vehicule][AssuranceTransitoireValue]') === 'selling_now') && (
                                <BulleAide
                                    icon={info}
                                    title={getBulleAideContent().title}
                                    text={getBulleAideContent().text}
                                    className={'mt-4 col-lg-8 offset-lg-2 col-md-12'}
                                />
                            )}

                            <button className={`btn btn-primary btn-arrow mt-4`} onClick={() => myPostPaySubmit()} disabled={hasErrorOnPage()}>
                                Souscrire
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <LargeSpinner message={'Nous rechargeons votre tarif !'} />
            )}
        </>
    );
};

export default Recapitulatif;
